(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.VisualLayersService = (function(superClass) {
    extend(VisualLayersService, superClass);

    function VisualLayersService(http, rootScope, q) {
      this.http = http;
      this.rootScope = rootScope;
      this.q = q;
      this.combineLayers = bind(this.combineLayers, this);
      this.byField = bind(this.byField, this);
      void 0;
    }

    VisualLayersService.prototype.byField = function(id, spp_id, year) {
      return this.http.post('backend/grower/layers/planting-rx/ng-visual-layers', {
        fields_id: id,
        spp_id: spp_id,
        year: year
      });
    };

    VisualLayersService.prototype.combineLayers = function(field_id, layers) {
      return this.http.post('backend/grower/layers/planting-rx/cross-crop', {
        field_id: field_id,
        layers: layers
      }).then((function(_this) {
        return function(response) {
          var ref;
          if (((ref = response.data.status) != null ? ref.type : void 0) !== 'success') {
            return _this.q.reject(response.data);
          }
          return response.data.data;
        };
      })(this));
    };

    return VisualLayersService;

  })(Service);

}).call(this);
